<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <a
    class="
      relative flex items-center justify-center overflow-hidden rounded-[20px] bg-main-blue p-5 text-base font-medium
      leading-normal tracking-[-0.01em] text-white !no-underline transition-opacity duration-300 hover:opacity-[.7]
    "
    href="#"
  >
    <div
      class="absolute bottom-0 right-0 z-10 size-full bg-cover bg-center bg-no-repeat"
      :style="`background-image: url(https://cdn.itab.pro/partner/background-pattern.png)`"
    />

    <span class="relative z-20">
      {{ title }}
    </span>
  </a>
</template>
